<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <table class="table">
        <thead>
            <tr>
                <!-- <th scope="col">Code</th> -->
                <th scope="col">Methode</th>
                <th scope="col">Vak</th>
                <th scope="col">Module</th>
                <th scope="col">Periode</th>
                <th scope="col">Aantal</th>
                <th width="30"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of paginatedItems">
                <!-- <td class="cursor-pointer">
                    {{item['course']['code']}}
                </td> -->
                <td class="cursor-pointer">
                    {{item['course']['name']}}
                </td>
                <td class="cursor-pointer">
                    {{item['section']['name']}}
                </td>
                <td class="cursor-pointer">
                    {{item['chapter']['name']}}
                </td>
                <td class="cursor-pointer">
                    {{item['period']['name']}}
                </td>
                <td class="cursor-pointer">
                    {{item['quantity']}}
                </td>
                <td>
                    <div ngbDropdown class="d-inline-block">
                        <button type="button" class="btn-table-dropdown" ngbDropdownToggle>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                <path
                                    d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            </svg>
                        </button>
                        <div ngbDropdownMenu>
                            <button (click)="openModal(item)" ngbDropdownItem>Wijzig</button>
                            <button (click)="delete(item)" ngbDropdownItem>Verwijder</button>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <app-pagination [currentPage]="currentPage" [itemsPerPage]="itemsPerPage"
        (pageChange)="handlePageChange($event)"></app-pagination>
</div>